import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { exitActivityToWorkshop } from 'a/hub/actions/workshopActions';
import {
  getSkillGamesProgressRatio,
  getSkillGamesProgressText,
} from 'a/hub/selectors/studentProgressSelectors';
import { getIsChallengeQuest } from 'a/hub/selectors/workshopSelectors';
import { FractionText, BaseEarlyExitModal, BatteryIcon } from '../sharedComponents';
import useWorkshopSfx from '../../../hooks/useWorkshopSfx';

const GameEarlyExitModal = ({ config, closeModal }) => {
  const dispatch = useDispatch();
  const isChallengeQuest = useSelector(getIsChallengeQuest);
  const completeRatio = useSelector(getSkillGamesProgressRatio);
  const fractionText = useSelector(getSkillGamesProgressText);
  const { heading = 'Progress Saved' } = config;

  const { audioMap, playSfxFromMap } = useWorkshopSfx();
  useEffect(() => {
    playSfxFromMap(audioMap.game_early_exit);
  }, []);

  const text =
    config.text && !isChallengeQuest
      ? config.text
      : 'Complete all the levels of a game to charge up the battery.';

  const onGoToWorkshopButtonPress = (e) => {
    closeModal(e);
    dispatch(exitActivityToWorkshop(config));
  };

  return (
    <BaseEarlyExitModal
      headerText={heading}
      descriptionText={text}
      onConfirm={onGoToWorkshopButtonPress}
      onCancel={closeModal}
      actionScope="game-early-exit-modal"
    >
      <BatteryIcon top={231} left={323} completeRatio={completeRatio} />
      <FractionText>{fractionText}</FractionText>
    </BaseEarlyExitModal>
  );
};

GameEarlyExitModal.propTypes = {
  config: PropTypes.object.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default GameEarlyExitModal;
